export const validate = {
  name_existed: '%%text%% existe déjà',
  name_blank: 'Veuillez saisir un nom pour votre %%text%%',
  no_product_selected: "Veuillez sélectionner d'abord un %%text%% que vous souhaitez concevoir",
  choose_at_least: 'Vous devez choisir au moins un %%text%%',
} as const;
